import React from "react";
import "./ProductSlider.css";
import PakistanColorsImg from "../assets/pak.png";

const products = [
  { id: 1, img: "/assets/paint1.png" },
  { id: 2, img: "/assets/paint2.png" },
  { id: 3, img: "/assets/paint3.png" },
  { id: 4, img: "/assets/paint4.png" },
  { id: 5, img: "/assets/paint5.png" },
  { id: 6, img: "/assets/paint6.png" },
  { id: 7, img: "/assets/paint7.png" },
  { id: 8, img: "/assets/paint8.png" },
];

export default function ProductSlider() {
  return (
    <section className="product-slidera">
      <div className="marquee">
        <div className="marquee-content">
          {/* Duplicate the array to make it loop seamlessly */}
          {products.concat(products).map((p, index) => (
            <div className="product-carda" key={index}>
              <img src={p.img} alt={`Paint Bucket ${index + 1}`} className="abc" />
            </div>
          ))}
        </div>
      </div>

      <img
        src={PakistanColorsImg}
        alt="پاکستان کے رنگ"
        className="urdu-headinga-img"
      />
    </section>
  );
}
